"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var bindingFunctions;
    (function (bindingFunctions) {
        function $rowLabel(dataContext) {
            return $dyn.getFieldObservable("_RowLabel_", dataContext);
        }
        bindingFunctions.$rowLabel = $rowLabel;
        function $command(controlParams, command) {
            var shouldThrottle = false;
            var async;
            var interactionCommandFunction = function interactionCommand(namedParameters, callback, completeCallBack, beforeExecuteCallback, throttleCallback, failureCallback) {
                // ShouldBlockOnExecution - setting this to true triggers the blocking div on the client once the interaction is processed.
                // ExecuteImmediate - setting this to true will cause the interaction to be processed right after it is queued
                // NOTE: Processed and queued are different. The interaction is not guaranteed to be processed after it is queued
                //       (unless ExecuteImmediate = true) and in some cases can be removed from the queue and or processed after
                //       other user interaction with the client. So if the interaction needs to stop user interaction immediately
                //       both ShouldBlockOnExecution and ExecuteImmediate need to be set to true. Otherwise the interaction will
                //       only block when / if the interaction is processed at some later time
                var e_1, _a;
                var _this = this;
                var _b;
                // check for timing between when the interaction is queued and processed to validate when an interaction needs to be ExecuteImmediate
                $dyn.log.blockUserInteraction && $dyn.log.blockUserInteraction("BlockUserInteraction: Interaction created CommandName: %s", command.CommandName);
                var ignoreBlockingDiv = function () {
                    return _this && _this.IgnoreBlockingDiv && _this.IgnoreBlockingDiv(command.CommandName);
                };
                var shouldBlockDeferred = command.Properties.ShouldBlockDeferred;
                var commandInteraction = {
                    $type: $dyn.serverForm.InteractionType.command,
                    CallbackId: "",
                    CommandName: command.CommandName,
                    complete: null,
                    completeCommand: null,
                    details: function () {
                        return $dyn.format("[Command interaction: role='{0}', command='{1}']", controlParams._element.getAttribute("data-dyn-role"), command.CommandName);
                    },
                    FailureCallbackId: "",
                    NamedParameters: {},
                    NoAsyncIncrement: false,
                    PositionalParameters: null,
                    PriorityPosition: false,
                    ResetThrottleTime: false,
                    RootId: 0,
                    ShouldBlockDeferred: function () {
                        return shouldBlockDeferred;
                    },
                    ShouldBlockOnExecution: command.Properties.ShouldBlockOnExecution,
                    TargetId: controlParams._serverId,
                    Throttle: false,
                    ThrottleFirst: false,
                    ThrottleId: "0",
                    ThrottleTimestamp: 0,
                    ThrottleValue: 0,
                };
                commandInteraction.RootId = $dyn.serverForm.interactionHandler.getRootIdByElement(controlParams._element);
                if (namedParameters instanceof $.Event || namedParameters instanceof Event) {
                    namedParameters = undefined;
                }
                if (namedParameters !== undefined) {
                    if ($.isArray(namedParameters)) {
                        commandInteraction.PositionalParameters = namedParameters;
                        namedParameters = undefined;
                    }
                    else if (!$.isPlainObject(namedParameters)) {
                        $dyn.logWarning("Arguments should be a plain object for named parameters or an array for positioned parameters: %O", namedParameters);
                        namedParameters = { Arg1: namedParameters };
                    }
                }
                var control = $dyn.controlOptions(controlParams._element);
                if (command.ParameterBindings) {
                    if (!namedParameters) {
                        namedParameters = {};
                    }
                    var parameterKeys = Object.keys(command.ParameterBindings);
                    try {
                        for (var parameterKeys_1 = __values(parameterKeys), parameterKeys_1_1 = parameterKeys_1.next(); !parameterKeys_1_1.done; parameterKeys_1_1 = parameterKeys_1.next()) {
                            var key = parameterKeys_1_1.value;
                            var value_1 = command.ParameterBindings[key];
                            if (value_1) {
                                namedParameters[key] = $dyn.value(control[value_1]);
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (parameterKeys_1_1 && !parameterKeys_1_1.done && (_a = parameterKeys_1.return)) _a.call(parameterKeys_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                commandInteraction.beforeExecute = function () {
                    if (beforeExecuteCallback) {
                        $dyn.logWarning("beforeExecuteCallback should not be provided, barring exceptional cases, until this public api is refactored");
                        beforeExecuteCallback(commandInteraction);
                    }
                };
                commandInteraction.completeCommand = function () {
                    if (commandInteraction.complete) {
                        commandInteraction.complete();
                    }
                };
                commandInteraction.complete = completeCallBack;
                commandInteraction.NamedParameters = namedParameters;
                commandInteraction.ShouldBlockOnExecution = commandInteraction.ShouldBlockOnExecution && !ignoreBlockingDiv();
                // Whether or not this command when processed will flush the telemetry queue
                commandInteraction.Telemetry = $dyn.util.stringToBoolean(command.Properties.Telemetry);
                var throttleValue = Math.min((_b = command.Properties.ThrottleValue) !== null && _b !== void 0 ? _b : 0, $dyn.serverForm.maximumThrottleTime);
                var throttleFirst = command.Properties.ThrottleFirst;
                var throttleGroup = command.Properties.ThrottleGroup;
                commandInteraction.ThrottleFirst = throttleFirst;
                if (command.Properties.ResetThrottleTime) {
                    commandInteraction.ResetThrottleTime = command.Properties.ResetThrottleTime;
                }
                // Set the ThrottleId to the group id if it exists, otherwise use the control id
                if (throttleGroup !== undefined && throttleGroup !== null) {
                    commandInteraction.ThrottleId = commandInteraction.RootId + "_" + throttleGroup;
                    commandInteraction.Throttle = true;
                }
                else if (throttleValue > 0) {
                    commandInteraction.ThrottleId = control.Id + "_" + command.CommandName;
                }
                if (throttleValue > 0) {
                    throttleFirst = $dyn.util.stringToBoolean(throttleFirst);
                    commandInteraction.Throttle = shouldThrottle || throttleFirst;
                    if (commandInteraction.Throttle) {
                        commandInteraction.ThrottleValue = throttleValue;
                    }
                    if (!throttleFirst) {
                        // This is a throttled interaction, except for the first interaction which is not throttled.
                        // commandInteraction.Throttle is false for the first interaction, but should reset to true for
                        // every subsequent interaction, unless there is a delay in the next interaction, in which case
                        // that interaction will also not be throttled
                        shouldThrottle = true;
                        if (async) {
                            async.cancel();
                        }
                        async = $dyn.async(function () {
                            shouldThrottle = false;
                            async = undefined;
                        }, throttleValue, "Toggle throttle command");
                    }
                }
                if (!command.Properties.ExecuteImmediate) {
                    commandInteraction.NoAsyncIncrement = true;
                }
                var shouldProcess = false;
                if ((command.Properties && command.Properties.ExecuteImmediate) || (throttleValue > 0 && !commandInteraction.Throttle)) {
                    shouldProcess = true;
                }
                var channelOptions = {
                    channelType: $dyn.serverForm.InteractionChannelType.byRootId,
                    rootId: commandInteraction.RootId,
                };
                if (callback) {
                    if (commandInteraction.Throttle) {
                        $dyn.serverForm.interactionManager.queueThrottledCommandInteraction(commandInteraction, callback, channelOptions, shouldProcess, throttleCallback, failureCallback);
                    }
                    else {
                        $dyn.serverForm.interactionManager.queueCallbackCommandInteraction(commandInteraction, callback, channelOptions, shouldProcess, failureCallback);
                    }
                }
                else if (commandInteraction.Throttle) {
                    $dyn.serverForm.interactionManager.queueThrottledCommandInteraction(commandInteraction, null, channelOptions, shouldProcess, throttleCallback, failureCallback);
                }
                else {
                    $dyn.serverForm.interactionManager.queueInteraction(commandInteraction, channelOptions, shouldProcess, failureCallback);
                }
            };
            interactionCommandFunction._interactionCommand = true;
            return interactionCommandFunction;
        }
        bindingFunctions.$command = $command;
    })(bindingFunctions = $dyn.bindingFunctions || ($dyn.bindingFunctions = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=BindingFunctions.js.map
